import React from 'react';
import { Navigate } from 'react-router-dom';

import useAuthStore from 'src/hooks/auth/useAuthStore';
import config from 'src/shared/config';
import { mainPageRouteTables } from 'src/shared/routes';
import { getFirstAllowedMenuPath } from 'src/shared/utils/menuUtils';

const RootPage: React.FC = () => {
  const { authEntity } = useAuthStore();
  const path =
    getFirstAllowedMenuPath(authEntity ? authEntity.menus : [], mainPageRouteTables) ||
    config.url('/errors/forbidden');
  console.log('RootPage');
  console.log('path:', path);
  return <Navigate to={path} />;
  // console.log("RootPage")
  // const { pathname } = useLocation();
  // return <span>Root Page!!!{pathname}</span>;
};

export default RootPage;
